import { useHistory } from "react-router-dom";
import { HISTORY_KEY } from "src/constants/UrlConstants";
import { useGridFilterStore } from "src/store/useGridFilters/useGridFilterStore";
import { markPendingMainGridScrollPreserve } from "src/utils/scrollSync";
import { MAX_HISTORY_ENTRIES, ROUTE_PATHS } from "src/utils/constants";
import { createCookie, getCookie } from "src/utils/cookies";
import { getUrlIds } from "./useGridMainLogic";

const useSmartGoBack = () => {
  const history = useHistory();
  const SET_FILTER = useGridFilterStore((state) => state.SET_MAIN_FILTER);
  const gridFilters = useGridFilterStore((state) => state.gridMainFilters);

  const saveHistory = (paths) => {
    createCookie(HISTORY_KEY, encodeURIComponent(JSON.stringify(paths)), null);
  };

  const isMainProductsPath = (path) =>
    path?.startsWith(ROUTE_PATHS.PRODUCTS) &&
    !path?.startsWith(ROUTE_PATHS.BUNDLE_PRODUCTS) &&
    !path?.startsWith(ROUTE_PATHS.PRODUCT_SEARCH);

  const navigateTo = (path) => {
    if (isMainProductsPath(path)) {
      const urlIds = getUrlIds(path);
      if (urlIds) {
        const needsSync =
          urlIds.universeId !== gridFilters.universeId ||
          urlIds.gridReferenceId !== gridFilters.gridReferenceId ||
          urlIds.parentGridId !== gridFilters.parentGridId;

        if (needsSync) {
          markPendingMainGridScrollPreserve();
          SET_FILTER("gridReferenceId", urlIds.gridReferenceId, {
            gridReferenceId: urlIds.gridReferenceId,
            universeId: urlIds.universeId,
            parentGridId: urlIds.parentGridId,
          });
        }
      }
    }

    history.push(path);
  };

  const canUseBrowserBack = () => {
    
    const historyPath = Array.isArray(getCookie(HISTORY_KEY))
      ? getCookie(HISTORY_KEY)
      : [];

    const lastPath = historyPath.length > 0 ? historyPath[historyPath.length - 1] : null;
    const isLastPathProducts = isMainProductsPath(lastPath);
    return window.history.length > 1 && isLastPathProducts;
  };

  const smartGoBack = () => {
    if (canUseBrowserBack()) {
      window.history.back();
      return;
    }

    let historyPath = Array.isArray(getCookie(HISTORY_KEY))
      ? getCookie(HISTORY_KEY)
      : [];

    const currentPath = history.location.pathname + history.location.search;

    if (historyPath.length === 0) {
      navigateTo(ROUTE_PATHS.PRODUCTS);
      return;
    }

    if (historyPath.length > MAX_HISTORY_ENTRIES) {
      historyPath = historyPath.slice(-MAX_HISTORY_ENTRIES);
      saveHistory(historyPath);
    }

    const lastPath = historyPath[historyPath.length - 1];
    historyPath.pop();

    const currentPathname = currentPath.split('?')[0];
    const lastPathname = lastPath?.split('?')[0];

    if (lastPathname === currentPathname) {
      if (historyPath.length >= 1) {
        const previous = historyPath.pop();
        saveHistory(historyPath);

        navigateTo(previous);
      } else {
        navigateTo(ROUTE_PATHS.PRODUCTS);
      }
    } else {
      saveHistory(historyPath);

      navigateTo(lastPath);
    }
  };

  return smartGoBack;
};

export default useSmartGoBack;